import { cn } from '../lib/utils'

export interface PageSkeletonProps {
  variant?: 'list' | 'detail' | 'board'
  className?: string
}

const blockClass = 'rounded-xl border border-streep-border/60 bg-streep-surface-alt'

/**
 * Generieke laad-skeleton voor route-segmenten (loading.tsx).
 * Header-balk + content-blokken met pulse. 1-koloms-vriendelijk:
 * geen vaste breedtes, dus bruikbaar in portal (375px) én backoffice.
 */
export function PageSkeleton({ variant = 'list', className }: PageSkeletonProps) {
  return (
    <div
      className={cn('w-full animate-pulse space-y-4 px-4 py-6 md:px-8', className)}
      aria-hidden="true"
    >
      {/* Header-balk */}
      <div className={cn(blockClass, 'h-8 w-2/5 max-w-xs rounded-lg')} />

      {variant === 'list' && (
        <div className="space-y-3 pt-2">
          {[0, 1, 2, 3, 4].map((i) => (
            <div key={i} className={cn(blockClass, 'h-16 w-full')} />
          ))}
        </div>
      )}

      {variant === 'detail' && (
        <div className="space-y-4 pt-2">
          <div className={cn(blockClass, 'h-40 w-full')} />
          <div className={cn(blockClass, 'h-24 w-full')} />
          <div className={cn(blockClass, 'h-24 w-full')} />
        </div>
      )}

      {variant === 'board' && (
        <div className="grid grid-cols-2 gap-3 pt-2 sm:grid-cols-3 lg:grid-cols-5">
          {[0, 1, 2, 3, 4].map((i) => (
            <div key={i} className={cn(blockClass, 'h-72 w-full')} />
          ))}
        </div>
      )}
    </div>
  )
}
